// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3f37v","rightAdornment":"Header_rightAdornment__30zIQ"};